import React, { useEffect, useRef, useState } from 'react'
import { GrMoreVertical } from "react-icons/gr";
import { LuSearch } from "react-icons/lu";
import Pagination from "../../components/pagination/pagination";
import { useNavigate } from 'react-router-dom';
import AssignedTeams from '../../components/modals/documets/assignedTeams';
import AssignedUsers from '../../components/modals/documets/assignedUsers';
import CustomButton from '../../components/button/button';
import { documentsDelete, documentsListAction } from '../../redux/actions/documentAction';
import { useDispatch } from 'react-redux';
import errorToast from '../../components/toasts/errorToast';
import { availableLanguages } from '../../components/data/languageData';
import moment from 'moment';
import ReactSelectFiled from '../../components/forms/reactSelect';
import { formatDateTime, getLangName, truncateString } from '../../components/helper';
import DeleteConfirmModal from '../../components/modals/confirmation/delete-confirmation-modal';
import { useAuth } from '../../context/AuthContext';

export const Documents = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [filteredData, setFilteredData] = useState([]);
    const [fileNameFilter, setfileNameFilter] = useState("");
    const [emailFilter, setEmailFilter] = useState("");
    const [statusFilter, setStatusFilter] = useState("");
    const [pageFilter, setPageFilter] = useState("");
    const [sourceLangFilter, setSourceLangFilter] = useState("");
    const [filtersApplied, setFiltersApplied] = useState(false);
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")

    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [paginationData, setPaginationData] = useState({});
    const [showOptions, setShowOptions] = useState(false);
    const [showClearIndex, setShowClearIndex] = useState(null);
    const dropdownRef = useRef(null);
    const { isAdmin, isTeamLead } = useAuth();

    const [showModalTeam, setShowModalTeam] = useState(false);
    const [showModalUser, setShowModalUser] = useState(false);
    const [selectAll, setSelectAll] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [sortColumn, setSortColumn] = useState(null);
    const [sortOrder, setSortOrder] = useState('asc');

    const [showDeleteModal, setshowDeleteModal] = useState(false)
    const [selectedId, setSelectedId] = useState('')

    // Function to handle checkbox changes
    const handleCheckboxChange = (docId) => {
        if (selectedItems.includes(docId)) {
            setSelectedItems(selectedItems.filter(item => item !== docId));
        } else {
            setSelectedItems([...selectedItems, docId]);
        }
    };

    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedItems([]);
        } else {
            setSelectedItems(filteredData.map((data) => data?.id));
        }
        setSelectAll(!selectAll);
    };

    const handleCloseModalTeam = () => {
        setShowModalTeam(false);
    };

    const handleCloseModalUser = () => {
        setShowModalUser(false);
    };

    useEffect(() => {
        if (filtersApplied) {
            setLoading(true);
            dispatch(documentsListAction({
                page, page_size: rowsPerPage,
                file_name: fileNameFilter,
                status: statusFilter,
                source_lang: sourceLangFilter,
                uploadedBy: emailFilter,
                no_of_pages: pageFilter,
                from_date: startDate,
                to_date: endDate,
            }, onSuccess, onError));
        }
    }, [page, rowsPerPage, fileNameFilter, statusFilter, sourceLangFilter, emailFilter, pageFilter, startDate, endDate, dispatch]);


    const onSuccess = (data) => {
        setPaginationData(data?.data?.data?.pagination);
        setFilteredData(data?.data?.data?.documents);
        setLoading(false);
    };
    const onError = (data) => {
        errorToast(data?.data?.message);
        setLoading(false);
    };

    const handleSort = (column) => {
        const newSortOrder = sortColumn === column && sortOrder === 'asc' ? 'desc' : 'asc';
        const sortedData = [...filteredData].sort((a, b) => {
            if (a[column] < b[column]) return newSortOrder === 'asc' ? -1 : 1;
            if (a[column] > b[column]) return newSortOrder === 'asc' ? 1 : -1;
            return 0;
        });
        setSortColumn(column);
        setSortOrder(newSortOrder);
        setFilteredData(sortedData);
    };

    const handleMoreOptions = (item, index) => {
        setShowClearIndex(index);
        setShowOptions(!showOptions);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setShowOptions(false);
            setShowClearIndex(null);
        }
    };

    // Function to apply filters and fetch filtered data
    const handleApplyFilters = () => {
        setLoading(true);
        setFiltersApplied(true);
        dispatch(documentsListAction({
            page,
            page_size: rowsPerPage,
            file_name: fileNameFilter,
            status: statusFilter,
            source_lang: sourceLangFilter,
            uploadedBy: emailFilter,
            no_of_pages: pageFilter,
            from_date: startDate,
            to_date: endDate,
        }, onSuccess, onError));
    };

    const handleClear = () => {
        console.log(filtersApplied);
        setLoading(false);
        setfileNameFilter('');
        setStatusFilter('');
        setEmailFilter('')
        setSourceLangFilter('');
        setStartDate('');
        setEndDate('')
        setPageFilter('');
        setFiltersApplied(false);
    };
    const handleGetAllRecords = () => {
        setLoading(true);
        setfileNameFilter('');
        setStatusFilter('');
        setSourceLangFilter('');
        setStartDate('');
        setEndDate('')
        setPageFilter('');
        setFiltersApplied(true);
        dispatch(
            documentsListAction(
                {
                    page, page_size: rowsPerPage,
                },
                onSuccess,
                onError
            )
        );
    };

    const handleDelete = (id) => {
        dispatch(documentsDelete({ id }, onDeleteSuccess, onError));
        setShowOptions(false);
        setShowClearIndex(null);
    };

    const onDeleteSuccess = () => {
        setLoading(true);
        dispatch(documentsListAction({
            page,
            page_size: rowsPerPage,
            file_name: fileNameFilter,
            status: statusFilter,
            source_lang: sourceLangFilter,
            uploadedBy: emailFilter,
            no_of_pages: pageFilter,
            from_date: startDate,
            to_date: endDate,
        }, onSuccess, onError));
    }

    return (
        <div className="d-flex overflow-auto vh-100" onClick={handleClickOutside}>
            <div className="w-100">
                <div className="w-100 d-flex align-items-center justify-content-between header border-bottom position-sticky top-0 bg-white py-2 z-1">
                    <h2 className="fs_20 fw_400 fn_Roboto text-start px-3 pt-1">Documents</h2>
                    <div className='d-flex align-items-center justify-content-end gap-3 px-3'>
                        {isAdmin &&
                            <CustomButton
                                className={`${selectedItems.length === 1 ? '' : 'gray'} fs_18 fw_400 fn_Roboto cursor_pointer ${selectedItems.length === 0 ? 'disabled' : ''}`}
                                style={{ height: '35px', width: '140px' }} variant={selectedItems.length === 1 ? 'primary' : 'secondary'}
                                onClick={() => {
                                    if (selectedItems.length === 1) {
                                        navigate(`/view-documents/${selectedItems}`);
                                    } else {
                                        errorToast('Please Select Only One Document To Get Summary');
                                    }
                                }}
                            >
                                Get Summary
                            </CustomButton>
                        }
                        {isAdmin &&
                            <CustomButton
                                className={`${selectedItems.length === 0 ? 'gray' : ''} fs_18 fw_400 fn_Roboto cursor_pointer  ${selectedItems.length === 0 ? 'disabled' : ''}`}
                                style={{ height: '35px', width: '140px' }} variant={selectedItems.length > 0 ? 'primary' : 'secondary'}
                                onClick={() => {
                                    if (selectedItems.length > 0) {
                                        navigate('/assign-teams', { state: { selectedItems } });
                                    }
                                }}
                            >
                                Assign To Team
                            </CustomButton>
                        }
                        {isAdmin &&
                            <CustomButton className='cursor_pointer fs_18 fw_400 fn_Roboto justify-content-end ' style={{ height: '35px', width: '150px' }} variant='primary' onClick={() => navigate('/upload-documents')}>Add Document</CustomButton>
                        }
                    </div>

                </div>
                <div>
                    <div className="d-flex flex-wrap gap-3 p-3">
                        <div className='text-start'>
                            <span className="">Document Name</span>
                            <div className='' style={{ width: '14rem' }}>
                                <input
                                    type='text'
                                    name='file_name'
                                    className='input-field w-100'
                                    placeholder="Enter name"
                                    value={fileNameFilter}
                                    onChange={(e) => setfileNameFilter(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className='text-start' style={{ width: '14rem' }}>
                            <ReactSelectFiled
                                onChange={(value) => setSourceLangFilter(value)}
                                options={availableLanguages}
                                label="Source Language"
                                value={sourceLangFilter}
                            />
                        </div>

                        <div className='text-start'>
                            <span className="">Uploaded By</span>
                            <div className='' style={{ width: '14rem' }}>
                                <input
                                    type='text'
                                    name='file_name'
                                    className='input-field w-100'
                                    placeholder="Email id"
                                    value={emailFilter}
                                    onChange={(e) => setEmailFilter(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className='text-start' style={{ width: '14rem' }}>
                            <ReactSelectFiled
                                onChange={(value) => setStatusFilter(value)}
                                options={[
                                    {
                                        label: "Unassigned",
                                        value: "Unassigned"
                                    },
                                    {
                                        label: "Assigned",
                                        value: "Assigned"
                                    },
                                    {
                                        label: "Translation In Progress",
                                        value: "Translation In Progress"
                                    },
                                    // {
                                    //     label: "In Review",
                                    //     value: "In Review"
                                    // },
                                    // {
                                    //     label: "Completed",
                                    //     value: "Completed"
                                    // },
                                    {
                                        label: "Published",
                                        value: "Published"
                                    },
                                    {
                                        label: "Failed",
                                        value: "Failed"
                                    }
                                ]}
                                label={"Status"}
                                value={statusFilter}
                            />
                        </div>

                        <div className='text-start'>
                            <span className="">Pages</span>
                            <div className='' style={{ width: '14rem' }}>
                                <input
                                    type='number'
                                    name='pages'
                                    className='input-field w-100'
                                    placeholder="Enter a number"
                                    value={pageFilter}
                                    onChange={(e) => setPageFilter(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className='text-start'>
                            <span className="">From Date</span>
                            <div className='' style={{ width: '14rem' }}>
                                <input
                                    type='date'
                                    name='startDate'
                                    className='input-field w-100'
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                    max={new Date().toISOString().split('T')[0]}
                                />
                            </div>
                        </div>
                        <div className='text-start'>
                            <span className="">To Date</span>
                            <div className='' style={{ width: '14rem' }}>
                                <input
                                    type='date'
                                    name='endDate'
                                    className='input-field w-100'
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                    max={new Date().toISOString().split('T')[0]}
                                />
                            </div>
                        </div>


                    </div>
                    <div className="d-flex flex-wrap justify-content-start gap-3 mx-3 pt-1 text-nowrap">
                        <CustomButton variant="primary" onClick={handleApplyFilters} disabled={!emailFilter && !fileNameFilter && !statusFilter && !sourceLangFilter && !pageFilter && !startDate && !endDate} >
                            Apply Filters
                        </CustomButton>
                        <CustomButton variant="primary" onClick={handleGetAllRecords}>
                            Show All
                        </CustomButton>
                        <CustomButton variant="secondary" onClick={handleClear}>
                            Clear Filters
                        </CustomButton>
                    </div>
                    {filtersApplied && (
                        <div className="m-3">
                            <div className="table-responsive overflow-auto w-100" style={{ minHeight: '22rem' }}>
                                <table className="table table-bordered " >
                                    <thead className="table-light">
                                        <tr className="text-start text-nowrap">
                                            {isAdmin && (
                                                <th width={'3%'} className='fw_400'>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectAll}
                                                        onChange={handleSelectAll}
                                                        aria-label="Select all documents"
                                                    />
                                                </th>
                                            )}
                                            <th width={'10%'} className='fw_400' onClick={() => handleSort('name')}>
                                                Document Name {sortColumn === 'name' && (sortOrder === 'asc' ? '↑' : '↓')}
                                            </th>
                                            <th width={'5%'} className='fw_400' onClick={() => handleSort('source_lang')}>
                                                Source Language {sortColumn === 'source_lang' && (sortOrder === 'asc' ? '↑' : '↓')}
                                            </th>
                                            {isTeamLead && (
                                                <th width={'5%'} className='fw_400' onClick={() => handleSort('targetLanguage')}>
                                                    Target Language {sortColumn === 'targetLanguage' && (sortOrder === 'asc' ? '↑' : '↓')}
                                                </th>
                                            )}
                                            {isTeamLead && (
                                                <th width={'10%'} className='fw_400' onClick={() => handleSort('targetDate')}>
                                                    Target Date {sortColumn === 'targetDate' && (sortOrder === 'asc' ? '↑' : '↓')}
                                                </th>
                                            )}
                                            {isAdmin && (
                                                <th width={'6%'} className='fw_400' onClick={() => handleSort('uploadBy')}>
                                                    Uploaded By {sortColumn === 'uploadBy' && (sortOrder === 'asc' ? '↑' : '↓')}
                                                </th>
                                            )}
                                            {!isAdmin && (
                                                <th width={'10%'} className='fw_400' onClick={() => handleSort('assignedBy')}>
                                                    Assigned By {sortColumn === 'assignedBy' && (sortOrder === 'asc' ? '↑' : '↓')}
                                                </th>
                                            )}
                                            {!isTeamLead && !isAdmin && (
                                                <th width={'10%'} className='fw_400' onClick={() => handleSort('task')}>
                                                    Task {sortColumn === 'task' && (sortOrder === 'asc' ? '↑' : '↓')}
                                                </th>
                                            )}
                                            {isAdmin && (
                                                <th width={'10%'} className='fw_400' onClick={() => handleSort('assigned_teams')}>
                                                    Assigned Team {sortColumn === 'assigned_teams' && (sortOrder === 'asc' ? '↑' : '↓')}
                                                </th>
                                            )}
                                            <th width={'8%'} className='fw_400' onClick={() => handleSort('status')}>
                                                Status {sortColumn === 'status' && (sortOrder === 'asc' ? '↑' : '↓')}
                                            </th>
                                            {/* <th width={'5%'} className='fw_400' onClick={() => handleSort('no_of_pages')}>
                                                Pages {sortColumn === 'no_of_pages' && (sortOrder === 'asc' ? '↑' : '↓')}
                                            </th>
                                            <th width={'5%'} className='fw_400'>
                                                Comments
                                            </th>
                                             */}
                                            <th width={'8%'} className='fw_400' onClick={() => handleSort('no_of_pages')}>
                                                {isAdmin ? "Created Date" : "Assigned Date"} {sortColumn === 'no_of_pages' && (sortOrder === 'asc' ? '↑' : '↓')}
                                            </th>
                                            {/* {(isAdmin || isTeamLead === "true") && ( */}
                                            <th width={'2%'} className='fw_400'></th>
                                            {/* )} */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan="9">
                                                    Loading...
                                                </td>
                                            </tr>
                                        ) : filteredData?.length > 0 ? (
                                            filteredData?.map((item, index) => (
                                                <tr key={index} className='text-start'>
                                                    {isAdmin && (
                                                        <td>
                                                            <input
                                                                type="checkbox"
                                                                checked={selectedItems.includes(item.id)}
                                                                onChange={() => handleCheckboxChange(item.id)}
                                                                aria-label={`Select document ${item?.name}`}
                                                            />
                                                        </td>
                                                    )}
                                                    <td title={item?.name}>
                                                        <a href={`view-documents/${item.id}`} className='cursor_pointer text-decoration-none' >
                                                            {truncateString(item?.name)}
                                                        </a>
                                                    </td>
                                                    <td>{getLangName(item?.source_lang)}</td>
                                                    {isTeamLead && (
                                                        <>
                                                            <td>{item?.assignedTeam?.target_lang?.map((lang) => `${getLangName(lang)} (${lang})`).join(", ")}</td>
                                                        </>
                                                    )}
                                                    {isTeamLead && (
                                                        <>
                                                            <td>{moment.utc(item?.assignedTeam?.target_date).format("MMM DD, YYYY hh:mm A")}</td>
                                                        </>
                                                    )}
                                                    {isAdmin && (
                                                        <td>{item?.uploadedUser?.email}</td>
                                                    )}

                                                    {isTeamLead && (
                                                        <td>
                                                            {item?.assignedTeam?.assignedBy?.email}
                                                        </td>
                                                    )}
                                                    {!isTeamLead && !isAdmin && (
                                                        <td>
                                                            {item?.translationJobs[0]?.user?.email}
                                                        </td>
                                                    )}
                                                    {!isTeamLead && !isAdmin && (
                                                        <td>
                                                            {item?.translationJobs[0]?.post_edit_status}
                                                        </td>
                                                    )}
                                                    {isAdmin && (
                                                        <td>
                                                            {item?.assignedTeams?.map((team) => team?.team?.name).join(', ')}
                                                        </td>
                                                    )}
                                                    <td className={item?.status === 'Failed' ? 'text-danger' : ''}>{item?.status}</td>
                                                    {/* <td>{item?.no_of_pages}</td>
                                                    <td className='text-wrap' title={item?.comments}>{truncateString(item?.comments, 10)}</td>
                                                    */}
                                                    {isTeamLead ? (
                                                        <>
                                                            <td>{moment(item?.assignedTeam?.createdAt).format('MM/DD/YY, hh:mm A')}</td>
                                                        </>
                                                    ) : <td >{moment(item?.createdAt).format('MM/DD/YY, hh:mm A')}</td>
                                                    }

                                                    {/* {isAdmin || isTeamLead === "true" ? ( */}
                                                    <td>
                                                        <GrMoreVertical
                                                            className="cursor_pointer"
                                                            onClick={() => handleMoreOptions(item, index)}
                                                        />
                                                        {showOptions && showClearIndex === index && (
                                                            <div className="position-relative" ref={dropdownRef}>
                                                                <div className="position-absolute" style={{ left: "-5rem" }}>
                                                                    <div className="card" style={{ width: '5rem' }}>
                                                                        <div className="card-body p-2">
                                                                            <label className="d-block cursor_pointer hover-effect text-nowrap" onClick={() => navigate(`/view-documents/${item.id}`)}>View</label>
                                                                            {isAdmin && (
                                                                                <>
                                                                                    <label className="d-block text-danger cursor_pointer hover-effect" onClick={() => { setSelectedId(item); setshowDeleteModal(true) }} >Delete</label>
                                                                                </>
                                                                            )}
                                                                            {/* {isTeamLead === "true" && isAdmin === "false" && (
                                                                            <label className="d-block mb-2 cursor_pointer hover-effect text-nowrap" onClick={() => navigate('/assign-user', { state: { document_id: item.id } })}>Assign to Users</label>

                                                                        )} */}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </td>
                                                    {/* ) : null} */}
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="9">No rows to display</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    )}
                    {!loading && filtersApplied && (
                        <div className="mx-4 pb-3 d-flex justify-content-end">
                            <Pagination
                                data={paginationData}
                                nextFunc={() => setPage(page + 1)}
                                prevFunc={() => setPage(page - 1)}
                                setPageRowFunc={(value) => {
                                    setPage(1);
                                    setRowsPerPage(value);
                                }}
                            />
                        </div>
                    )}
                </div>
                <AssignedTeams show={showModalTeam} handleClose={handleCloseModalTeam} />
                <AssignedUsers title='Assign Users' show={showModalUser} handleClose={handleCloseModalUser} showAddRemoveButtons={true} />
                <DeleteConfirmModal
                    isOpen={showDeleteModal}
                    onClose={() => setshowDeleteModal(false)}
                    deletConfirmationMsg={`Are you sure you want to delete ${selectedId?.name} document and all its related data?`}
                    type={"Document"}
                    onDelete={handleDelete}
                    id={selectedId?.id}
                />
            </div >
        </div >
    )
}